// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  settlementId: __t.u64().primaryKey().name("settlement_id"),
  worldId: __t.u64().name("world_id"),
  shortageStreak: __t.u32().name("shortage_streak"),
  lastAmendAt: __t.timestamp().name("last_amend_at"),
  lastNormAt: __t.timestamp().name("last_norm_at"),
  lastSpeechAt: __t.timestamp().name("last_speech_at"),
  lastCuriosityAt: __t.timestamp().name("last_curiosity_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
